module.exports = __webpack_public_path__ + "static/media/icon_03.486d4812.png";